module.exports = __webpack_public_path__ + "static/media/coach2.afb8a70f.jpg";